<template>
  <div class="rp-helpdesk-conversation-message-get-email">
    <div class="form" :disabled="isDisabled" :style="{
				borderTopColor: activeColor
			}">
      <div class="qualifying-properties">
        <div
          v-for="(property, index) in getFields"
          :key="property.name"
          class="qualifying-property"
        >
          <template v-if="property.value">
            <div class="property-value-wrapper">
              <div
                class="property-value-wrapper__submitted"
              >{{getTranslatedDisplayName('inputPropDisplayNames.'+property.propertyName, property.displayName)}} {{$t('inputFields.submitted')}}:</div>
              <VMargin :unit=".10" />
              <div class="property-value-content-wrapper">
                <span class="property-value-content-icon" :style="{ color: '#85ce61' }">
                  <i class="el-icon-success"></i>
                </span>
                <HMargin :unit=".3" />
                <span v-if="property.dataType === 'date'" class="property-value-content-wrapper__content">{{ getFormattedDateValue(property.value) }}</span>
                <span v-else-if="property.dataType === 'file'" class="property-value-content-wrapper__content">
                  <span
                    v-for="(fileUrl, index) in  property.value"
                    :key="fileUrl+index"
                  >
                  <a
                    class="rp-download-file-from-form"
                    target="_blank"
                    :href="RICHPANEL_DATA+fileUrl"
                    
                  >{{ getFormattedFileName(fileUrl) }} </a>
                  <span v-if="index !== property.value.length - 1 && property.value.length > 1">, </span>
                  </span>
                  
                </span>
                <span v-else-if="property.dataType === 'multiSelect'" class="property-value-content-wrapper__content">{{ property.value }}</span>
                <span v-else class="property-value-content-wrapper__content">{{ property.value }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            {{property.value}}
            <FormItem 
              :showAllDataTypes="true" 
              :property="property" 
              @handleClick="handleClick" 
              @focus="handleFocus"
              :showSubmit="true"
            />
          </template>
          <VMargin v-if=" index+1 !== lengthOfFields" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MediaTypeText from "./MediaTypeText";
import FormItem from "./MediaSubForm/FormItem";
import {
  DateTime
} from 'luxon'
export default {
  components: {
    FormItem
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      text: "",
      disabled: false,
      fields: {},
      isLoadingMap: {},
      EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      PHONE_REGEX: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
      RICHPANEL_DATA: "https://s3-us-west-2.amazonaws.com/richpanel-data/"
    };
  },

  mounted() {
    this.updateFields();
  },

  watch: {
    ["message.mediaFormValue"](val) {
      this.updateFields();
    }
  },

  computed: {
    isDisabled() {
      return Object.values(this.fields).some(({ isLoading }) => !!isLoading);
    },
    lengthOfFields() {
      return Object.keys(this.fields).length;
    },
    getFields() {
      return Object.values(this.fields);
    },
    propertiesObject() {
      const o = {};
      this.properties.forEach(prop => (o[prop.propertyName] = prop));
      return o;
    },

    value() {
      return this.message.mediaValue;
    },

    // isValid() {
    //     return this.value !== EMAIL_FORM_NULL_VALUE;
    // },

    ...mapGetters({
      properties: "tenantProperties",
      conversationProperties: 'conversationProperties'
    }),
    activeColor() {
			try {
        return this.$root.configuration.style.activeColor || "#004e96";
      } catch (e) {
        return "#004e96";
      }
    },
    propertiesObject() {
      const o = {};
      this.properties.forEach(prop => (o[prop.propertyName] = prop));
      return o;
    },
     conversationPropertiesObject() {
        const o = {};
        this.conversationProperties.forEach(prop => o[prop.propertyName] = prop);
        return o;
    },
  },

  methods: {
    handleFocus(property) {
        //don't show error message on  focus
        this.isError = false;
        this.$set(property, 'isError', false);
    },
    getFormattedDateValue(timestamp) {
      if(timestamp){
        timestamp = parseInt(timestamp)
      }
      return DateTime.fromMillis(timestamp).setLocale(this.$root.defaultLanguage).toFormat('LLLL dd, yyyy')
    },

    getFormattedFileName(fileUrl) {
      const [ParentBucket, Bucket, Name] = fileUrl.split("/");
      return Name;
    },

    updateFields() {
      this.message.mediaFormValue.forEach(({ name, value, dataType, groupName }) => {
        // if (this.propertiesObject && !this.propertiesObject[name]) return;
        let type = "text";
        let dropdownListOption = [];
        let dropdownOption = [];
        let property;
        if(groupName && groupName === 'Conversation Data') { 
          if(this.conversationPropertiesObject && this.conversationPropertiesObject[name]) {
            property = this.conversationPropertiesObject[name];
          }
        }
        else {
          if(this.propertiesObject && this.propertiesObject[name]) {
            property = this.propertiesObject[name];
          }
        }
        if(!property) {
          let combinationOfProperties = { ...this.conversationPropertiesObject, ...this.propertiesObject }
          if(combinationOfProperties && combinationOfProperties[name]) {
            property = combinationOfProperties[name];
          }
        }
        if(!property) {
          return;
        }
        type = property.type || type;
        dropdownOption = property.dropdownOption || dropdownOption;
        dropdownListOption = property.dropdownListOption || dropdownListOption;
        displayName = property.displayName || name;
        

        let displayName = displayName.replace(/([A-Z])/g, " $1").trim();
        const field = this.fields[name];
        if (value) {
          this.$set(this.fields, name, {
            name,
            displayName,
            value: this.getParsedValue({
              value,
              type: dataType || type || "text"
            }),
            vModelValue: value,
            dataType: dataType || type || "text",
            type,
            dropdownOption: dropdownListOption || dropdownOption || [],
            groupName: groupName || 'People Data',
          });
        } else if (field) {
          this.$set(this.fields, name, {
            name,
            displayName,
            value: this.getParsedValue({
              value,
              type: dataType || type || "text"
            }),
            vModelValue: field["vModelValue"],
            dataType: dataType || type || "text",
            type,
            dropdownOption: dropdownListOption || dropdownOption || [],
            required: true,
            groupName: groupName || 'People Data',
          });
        } else {
          this.$set(this.fields, name, {
            name,
            displayName,
            value: "",
            vModelValue: "",
            dataType: dataType || "text",
            type,
            dropdownOption: dropdownListOption || dropdownOption || [],
            required: true,
            groupName: groupName || 'People Data',
          });
        }
      });
    },
    getDisplayName(name) {
      if (this.propertiesObject[name]) {
        return this.propertiesObject[name];
      } else {
        return { displayName: name };
      }
    },
    getParsedValue({ value, type }) {
      try {
        return JSON.parse(value).formattedValue || value;
      } catch (e) {
        return value;
      }
    },
    getTranslatedDisplayName(translationPath, fallbackDisplayName) {
      try {
        let translationValue = this.$t(translationPath);
        if (translationValue === translationPath) {
          translationValue = fallbackDisplayName;
        }
        return translationValue;
      } catch (e) {
        console.error(e);
        return fallbackDisplayName;
      }
    },
    checkDataValidation(property) {
      if (property) {
        const { name, vModelValue, required } = property;
        if (name === "email") {
          if (this.EMAIL_REGEX.test(vModelValue)) {
            return true;
          } else {
            return false;
          }
        } else if (name === "phone") {
          if (this.PHONE_REGEX.test(vModelValue)) {
            return true;
          } else {
            return false;
          }
        } else {
          if(Array.isArray(vModelValue) && vModelValue.length === 0){
              this.isError = true;
              this.$set(property, 'isError', true);
              return false;
          }
          else if (!(vModelValue) && required) {
              this.isError = false;
              this.$set(property, 'isError', true);
              return false;
          }
          else {
              this.isError = false;
              this.$set(property, 'isError', false);
              return true;
          }
        }
      } else {
      }
      return true;
    },

    handleClick(property) {
      const { checkDataValidation } = this;
      const { vModelValue, groupName } = property;
      switch (property.type) {
        case "list":
          if (Array.isArray(vModelValue)) {
            property.vModelValue = vModelValue.join(", ");
          } else {
            if (vModelValue && vModelValue.trim()) {
              property.vModelValue = JSON.parse(vModelValue).join(", ");
            }
          }
          break;
        case "multiSelect":
          if (vModelValue.length > 0) {
            let joinedValues = "";
            vModelValue.forEach((val, index) => {
              if (index !== 0) {
                joinedValues += `, ${val}`;
              } else {
                joinedValues += val;
              }
            });
            property.vModelValue = joinedValues;
          }
          break;
        case "boolean":
          if (vModelValue) {
            property.vModelValue = "Yes";
          } else if (!vModelValue) {
            property.vModelValue = "No";
          }
          break;
        case "date":
          if (vModelValue) {
            property.vModelValue = JSON.stringify({
              formattedValue: vModelValue
            });
          }
          break;
        default:
          if (
            typeof vModelValue === "string" &&
            (!vModelValue || !vModelValue.trim())
          ) {
            break;
          } else {
            property.vModelValue = vModelValue;
          }
          break;
      }
      if (checkDataValidation(property)) {
        if (!property.vModelValue) {
          return;
        }
        this.$set(property, "isLoading", true);
        this.$emit("submit", {
          type: "form",
          message: this.message,
          data: { property }
        });
      } else {
        this.$set(property, 'isError', true);
      }
    }
  }
};
</script>

<style lang="scss">
.rp-helpdesk-conversation-message-get-email {
  .form {
    padding: 1.5rem;
    background: white;
    border: 1px solid #cccccc;
    border-top: 2px solid $color;
    border-radius: 5px;
    max-width: 500px;

    .label {
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
    }

    .input {
      margin-top: 0.75rem;

      .el-input {
        font-size: 13px;
        font-weight: $fontWeight;
      }
    }

    &[disabled="disabled"] {
      opacity: 0.5;
      pointer-events: none;
    }
  }
  .qualifying-properties {
    font-size: 13px;
    color: #4d4d4d;
    .rp-download-file-from-form {
      text-decoration: underline;
      color: $color;
      margin-right: 0.3rem;
      .rp-download-file-from-form:last-child {
        margin-right: 0rem;
      }
    }

    .property-value-wrapper {
      display: flex;
      flex-direction: column;
      .property-value-wrapper__submitted {
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        text-transform: capitalize;
        @include for-size(desktop-up){
          font-size: 16px;
          line-height: 1.6;
        }
      }

      .property-value-content-wrapper {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        @include for-size(desktop-up){
          font-size: 18px;
        }
        line-height: 22px;
        align-items: center;

        .property-value-content-wrapper__content {
          word-break: break-word;
        }
      }
    }

    .rp-messenger-form-item {
      margin-bottom: 0px;
    }

  }
}

.rp-helpdesk-conversation-message-get-email.value-submitted {
  .label {
    font-size: 10px;
  }
}
.rp-helpdesk-conversation-message-get-email.from-customer {
  flex-direction: row-reverse;
  display: flex;
  .form {
    text-align: left;
    max-width: 95%;
    overflow: hidden;
  }
}
.rp-qualifying-properties-error-msg {
  color: red;
  margin-top: 5px;
}
</style>
